import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/store";
import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";

import AppButton from "../components/buttons/AppButton";
import {
  verifyUserEmail,
  clearVerifyError,
} from "../redux/actions/authActions";

const EmailVerificationPage: React.FC = () => {
  const { token } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const hasRequested = useRef(false);

  const { loadingUserVerify, errorUserVerify } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    // Only dispatch if a token exists AND we haven't already requested it
    if (token && !hasRequested.current) {
      dispatch(verifyUserEmail(token));
      hasRequested.current = true; // Mark as requested immediately
    }
    return () => {
      dispatch(clearVerifyError());
    };
  }, [dispatch, token]);

  const isVerified = !loadingUserVerify && !errorUserVerify;

  return (
    <Container maxWidth="sm" sx={{ py: 15, textAlign: "center" }}>
      <Paper sx={{ p: 5, borderRadius: 4 }}>
        {loadingUserVerify ? (
          <Box sx={{ py: 5 }}>
            <CircularProgress color="secondary" size={60} sx={{ mb: 3 }} />
            <Typography variant="h5">Verifying your account...</Typography>
            <Typography color="textSecondary">
              Please do not close this window.
            </Typography>
          </Box>
        ) : errorUserVerify ? (
          <Box sx={{ py: 3 }}>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h5" color="error" gutterBottom>
              Verification Failed
            </Typography>
            <Alert severity="error" sx={{ mb: 3 }}>
              {errorUserVerify}
            </Alert>
            {/* <AppButton variant="contained" onClick={() => navigate("/login")}>
              Go to Login
            </AppButton> */}
          </Box>
        ) : (
          <Box sx={{ py: 3 }}>
            <CheckCircleOutlineIcon
              color="success"
              sx={{ fontSize: 80, mb: 2 }}
            />
            <Typography variant="h5" gutterBottom>
              Verification Successful!
            </Typography>
            <Typography color="textSecondary" sx={{ mb: 4 }}>
              Your email has been confirmed. You can now access all features of
              the Fiji Cloud ERP.
            </Typography>
            <AppButton variant="gradient" onClick={() => navigate("/login")}>
              Proceed to Login
            </AppButton>
          </Box>
        )}
      </Paper>
    </Container>
  );
};
export default EmailVerificationPage;
